(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/divide', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/divide'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.divide, global.convert);
    global.divide = mod.exports;
  }
})(this, function (exports, _divide2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.divide = undefined;

  var _divide3 = _interopRequireDefault(_divide2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by the division of the former number and the given number.
   * @function
   * @memberof math
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {number} divisor The second number in the division.
   * @return {Object} Returns the updated object.
   * @example divide({ nested: { prop: 1332 } }, 'nested.prop', 2) // => { nested: { prop: 666 } }
   * @see {@link https://lodash.com/docs#divide|lodash.divide} for more information.
   * @since 0.3.0
   */
  var divide = (0, _convert.convert)(_divide3.default);
  exports.divide = divide;
  exports.default = divide;
});